import { type ExperimentVariants, type Experiments } from '../experiments';
import { type useCustomerExperiments } from '../hooks/useCustomerExperiments';

export function getExperimentGroup<T extends Experiments>(
  exp: T,
  {
    experiments,
  }: Exclude<ReturnType<typeof useCustomerExperiments>['data'], undefined>
): ExperimentVariants<T> {
  const expId = exp * 100;
  const expArr = experiments
    .filter((e) => e.experiment >= expId && e.experiment <= expId + 99)
    .sort((a, b) => b.experiment - a.experiment);

  const value =
    expArr && expArr.length && expArr[0].variant_modulo !== undefined
      ? expArr[0].variant_modulo
      : -1;

  return value as ExperimentVariants<T>;
}
